module.exports = __webpack_public_path__ + "static/img/tab1.efa0f83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/tab1.png
// module id = mdIF
// module chunks = 0